import axiosInstance from "../config/axios";

export interface HrmsAccessRecord {
  user_id: string;
  read_access: boolean;
  write_access: boolean;
  delete_access: boolean;
  admin_access: boolean;
  employee_config_read_access: boolean;
  employee_config_write_access: boolean;
  salary_slip_read_access: boolean;
  salary_slip_write_access: boolean;
  is_reporting_manager?: boolean;
}

interface HrmsAccessResponse {
  data: HrmsAccessRecord[];
}

async function getUserAccess(): Promise<HrmsAccessRecord | null> {
  const response = await axiosInstance.get<HrmsAccessResponse>("/hrms/access");
  return response.data?.data?.[0] || null;
}

export const hrmsAccessService = {
  getUserAccess,
};

export default hrmsAccessService;
